"use strict";

exports.__esModule = true;
exports.replaceParams = replaceParams;
/**
 * replace params
 * @param {String} url a string containing placeholder params to be replaced
 * @param {Object} params a hashmap of paramKeys and their values
 * @return {string} the resultant endpoint url
 */
function replaceParams(url, params) {
  return Object.entries(params).reduce(function (endPoint, _ref) {
    var param = _ref[0],
      value = _ref[1];
    return value || value === 0 ? endPoint.replace(new RegExp("{" + param + "}", 'g'), "" + value) : endPoint.replace(new RegExp("&?" + param + "={" + param + "}", 'g'), '');
  }, url);
}